export default () => ({
  product: {
    buttonDestination: 'modal',
    styles: {
      product: {
        "@media (min-width: 601px)": {
          "max-width": "calc(25% - 20px)",
          "margin-left": "20px",
          "margin-bottom": "50px",
          width: "calc(25% - 20px)"
        },
      },
      button: {
        "font-weight": "100",
        color: "#fff",
        ":hover": {
          "background-color": "#b23030"
        },
        "background-color": "#b91c1c",
        ":focus": {
          "background-color": "#b23030"
        },
        "padding-left": "11px",
        "padding-right": "11px"
      }
    },
    order: ['price', 'button'],
    text: {
      button: "Add to cart"
    },
    iframe: false,
  },
  cart: {
    styles: {
      button: {
        ":hover": {
          "background-color": "#b23030"
        },
        "background-color": "#c63535",
        ":focus": {
          "background-color": "#b23030"
        }
      }
    },
    text: {
      total: "Subtotal",
      button: "Checkout"
    },
    popup: false,
    events: {
      afterInit: (cart) => {
        if(cart.model?.lineItems?.some(li => li.variant?.product?.id == 'gid://shopify/Product/8504237523097')) {
          window.showProductGrid()
        }
      },
    }
  },
  toggle: {
    styles: {
      toggle: {
        "background-color": "#c63535",
        ":hover": {
          "background-color": "#b23030"
        },
        ":focus": {
          "background-color": "#b23030"
        }
      }
    }
  }
})
